import * as React from "react";
import { cn } from "@/lib/utils.ts";

interface Props extends React.HTMLAttributes<HTMLDivElement> {
  variant? : "standard" | "centered";
  selected?: boolean;
}
export const PreviewDocumentUI = ({ variant, selected }: Props) => {
  return (
    <div
      className={cn(
        "w-full aspect-[3/4] rounded-lg border-2 p-4 flex flex-col gap-2 transition-colors",
        selected ? "border-primary bg-blue-50/40" : "border-slate-200 bg-white",
      )}
    >
      {variant === "standard" ? (
        <>
          <div className="h-3 w-16 bg-slate-200 rounded" />
          <div className="h-2 w-full bg-slate-200 rounded mt-1" />
          <div className="h-2 w-full bg-slate-200 rounded" />
          <div className="h-2 w-3/4 bg-slate-200 rounded" />
          <div className="flex-1" />
          <div className="h-2 w-2/3 bg-slate-200 rounded" />
          <div className="flex-1" />
          <div className="flex gap-2 mt-auto">
            <div className="h-12 w-12 bg-slate-200 rounded" />
            <div className="h-12 w-12 bg-slate-200 rounded" />
            <div className="h-12 w-12 bg-slate-200 rounded" />
          </div>
        </>
      ) : (
        <>
          <div className="h-3 w-16 bg-slate-200 rounded self-center" />
          <div className="h-2 w-full bg-slate-200 rounded mt-1" />
          <div className="h-2 w-full bg-slate-200 rounded" />
          <div className="h-2 w-3/4 bg-slate-200 rounded self-center" />
          <div className="flex-1" />
          <div className="h-2 w-2/3 bg-slate-200 rounded self-center" />
          <div className="flex-1" />
          <div className="flex gap-2 mt-auto justify-center">
            <div className="h-12 w-12 bg-slate-200 rounded" />
            <div className="h-12 w-12 bg-slate-200 rounded" />
            <div className="h-12 w-12 bg-slate-200 rounded" />
            <div className="h-12 w-12 bg-slate-200 rounded" />
          </div>
        </>
      )}
    </div>
  );
};
